// Cart drawer close
const closeCartPopup = () => {
  document.querySelector(".cart-drawer .side-panel-close").click();
}
// Cart drawer close

document
  .querySelectorAll(".cycs-options-wrap .cycs-ow-option")
  .forEach((item) => {
    item.addEventListener("click", function () {
      removeActiveclass(".cycs-options-wrap .cycs-ow-option");
      // removeBGColor();
      this.classList.add("active");
      const imageSrc = this.dataset.src;
      const imageTitle = this.dataset.title;
      const imageSubtext = this.dataset.subtext;
      const imageText = this.dataset.text;
      const bgcolor = this.dataset.color;
      const fontColor = this.dataset.fontcolor;
      if (imageSrc) {
        // document.querySelector(".cycs-image-wrapper img").src = imageSrc;
        document
          .querySelectorAll(".cycs-image-wrapper")
          .forEach((itemImage) => {
            itemImage.querySelector("img").src = imageSrc;
          });
      }
      document.querySelector(".cycs-content-wrapper .cycs-title").innerHTML = imageTitle;
      if (imageSubtext) {
        document.querySelector(".cycs-content-wrapper .cycs-subtext").innerHTML = imageSubtext;
      }
      if (imageText) {
        document.querySelector(".cycs-content-wrapper .cycs-text").innerHTML = imageText;
      }

      console.log("bgcolor ", bgcolor);
      item.closest(".cycs-section").style.backgroundColor = bgcolor;
      // item.style.backgroundColor = bgcolor;
      item
        .closest(".cycs-content-wrapper")
        .style.setProperty("--option-fontcolor", fontColor);
    });
  });

document
  .querySelectorAll(".cyfs-options-wrap .cyfs-ow-option")
  .forEach((item, index) => {
    item.addEventListener("click", function () {
      console.log('index ',index);
      removeActiveclass(".cyfs-options-wrap .cyfs-ow-option");
      this.classList.add("active");
      const imageSrc = this.dataset.src;
      const imageMobileSrc = this.dataset.msrc;
      const imageTitle = this.dataset.title;
      const imageText = this.dataset.text;
      filterCompareDetails(index);
      if (imageSrc) {
        document.querySelector(".cyfs-image-wrapper img.for_desk").src = imageSrc;
      }
      if (imageMobileSrc) {
        document.querySelector(".cyfs-image-wrapper img.for_mob").src = imageMobileSrc;
      }
      document.querySelector(".cyfs-content-wrapper .cyfs-title").innerHTML =
        imageTitle;
      document.querySelector(".cyfs-content-wrapper .cyfs-text").innerHTML =
        imageText;
    });
  });


const filterCompareDetails = (index) => {
  document.querySelectorAll('.filter-details-wrap .fdw-wrap').forEach(item => {
    item.classList.remove('active');
  });
  document.querySelector(`.filter-details-wrap .fdw-wrap[data-index="${index}"]`).classList.add('active');
}

 document.querySelectorAll('.filter-details-wrap .fdw-wrap').forEach((item, index) => {
     item.addEventListener('click', function(){
         $('.cyfs-options-wrap .cyfs-ow-option').eq(index).click();
     });
 });

const removeActiveclass = (cclass) => {
  document.querySelectorAll(cclass).forEach((item) => {
    item.classList.remove("active");
  });
};

const removeBGColor = () => {
  document
    .querySelectorAll(".cycs-options-wrap .cycs-ow-option")
    .forEach((item) => {
      item.style.backgroundColor = "#fff";
    });
};

document.addEventListener("DOMContentLoaded", function () {
  const faqQuestions = document.querySelectorAll(".faq-question");

  faqQuestions.forEach((question) => {
    question.addEventListener("click", function () {
      this.classList.toggle("active");

      // const answer = this.nextElementSibling;
      // if (answer.style.display === "block") {
      //   answer.style.display = "none";
      // } else {
      //   answer.style.display = "block";
      // }
    });
  });
});

window.updateCartIconPrice = () => {
  const amout_no_deciaml = document.querySelector('body').dataset.marketCurrency+'{{amount}}';
  fetch(window.Shopify.routes.root + "cart.js")
    .then((response) => response.json())
    .then((result) => {
      document.querySelector(
        "#cart-drawer-togglee .thb-items-price"
      ).innerHTML = Shopify.formatMoney(
        result.total_price,
        amout_no_deciaml
      ).replace(".00", "");
    })
    .catch((error) => console.error("Error fetching JSON data:", error));
};


/* auto-refile subscription */
document.querySelectorAll(".csw-sub-onetime .csw-type-wrap").forEach((item) => {
  item.addEventListener("click", function () {
    if (!this.classList.contains("active")) {
      document
        .querySelectorAll(".csw-sub-onetime .csw-type-wrap")
        .forEach((itemm) => {
          itemm.classList.remove("active");
        });
      this.classList.add("active");
      window.updateVariantSellingPlanPrice();
    }
  });
});

window.updateVariantSellingPlanPrice();
// window.nonWhiteNote();
/* end auto-refile subscription */

/* change choose your filter content */

document.querySelectorAll('fieldset.product-form__input[data-handle="choose-your-filter"] input').forEach((item) => {
    item.addEventListener("change", function () {
      const optionname = this.value;
      console.log('optionname ',optionname);
      document.querySelectorAll(".option-description-wrapper .fiter-option-desc").forEach((desc) => {
        desc.classList.remove("active");
      });
      document.querySelector(`.option-description-wrapper .fiter-option-desc[data-option="${optionname}"]`).classList.add("active");
    });
  });

/* custom tab js */

document.querySelectorAll('.ctw-cw-tabs .ctw-cw-btnwrap').forEach(item => {
    item.addEventListener('click', function(){
        if(!this.classList.contains('active')){
            document.querySelectorAll('.ctw-cw-tabs .ctw-cw-btnwrap').forEach(tab => {
                tab.classList.remove('active'); 
            });
            this.classList.add('active');
            const tabText = this.dataset.text;
            const tabName = this.dataset.title;
            document.querySelectorAll('.ctw-cw-content-wrap .ctw-cw-content').forEach(tab => {
                tab.classList.remove('active'); 
            });
            document.querySelector(`.ctw-cw-content-wrap .ctw-cw-content[data-title="${tabName}"]`).classList.add('active');
            // this.closest('.ctw-wrapper').querySelector('.section-header--description')?.innerHTML = tabText;
            
            // Clear existing timeout if any
            if (window.tabTimeout) {
                clearTimeout(window.tabTimeout);
            }
            tabProcessSlider();
        }
    });
});

const tabProcessSlider = () => {
    window.tabTimeout = setTimeout(function(){
        const tabButtons = document.querySelectorAll('.ctw-cw-tabs .ctw-cw-btnwrap');
        const activeTabButton = document.querySelector('.ctw-cw-tabs .ctw-cw-btnwrap.active');
        if (tabButtons && activeTabButton) {
          const tabLength = tabButtons.length - 1;
          const index = parseInt(activeTabButton.dataset.index);
          let nextIndex = index;
          if(tabLength > index){
              nextIndex += 1;
          }else{
              nextIndex = 0;
          }
          document.querySelector(`.ctw-cw-tabs .ctw-cw-btnwrap[data-index="${nextIndex}"]`).click();
        }
    }, 6000);
}

tabProcessSlider();


function crpButtonClick(button){
  button.classList.add('loading');
  const form = button.closest('form'); 
  addtocart(form);
}

function crpMakeVariantSelected(item ,vid){
  const hasActiveslide = item.closest('.slick-slide').classList.contains('slick-current');
  console.log('hasActiveslide ',hasActiveslide);
  if(hasActiveslide){
    const varientTitle = document.querySelector(`select.combine-variants-wrap option[value="${vid}"]`).dataset.title;
    const optionArr = varientTitle.split(' / ');
    optionArr.forEach(function(element) {
        console.log(element);
        document.querySelector(`.product-form__input input[value="${element}"]`).click();
    });
    document.querySelector('.cart-drawer side-panel-close.side-panel-close').click();
  }
}


function addtocart(form){
  const formData = new FormData(form);
      const formObject = {};
      formData.forEach((value, key) => {
          if (formObject[key]) {
              if (!Array.isArray(formObject[key])) {
                  formObject[key] = [formObject[key]];
              }
              formObject[key].push(value);
          } else {
              formObject[key] = value;
          }
      });
      let formDatacus = {'items': [{'id': formObject.id,'quantity': formObject.quantity}]};
      const combineOption = document.querySelector(`select.combine-variants-wrap option[value="${formObject.id}"]`);
      const fsid = combineOption?.dataset?.fsid;
      const fsellingid = combineOption.dataset.fsellingid;
      if(fsid){formDatacus.items.push({'id': fsid,'selling_plan':fsellingid,'quantity': formObject.quantity,properties: {'__main_product_id': formObject.id}})}
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(formDatacus)
      })
      .then(response => {
        // console.log('response ',response);
        window.cartUpdate();
        setTimeout(function() {
          document.querySelector('button.single-add-to-cart-button').classList.remove('loading');
        },1000);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
}

window.cartUpdate = () => {
   const form = document.querySelector('.product-form');
   fetch(`${window.Shopify.routes.root}cart?query=${document.querySelector('.cpfp-section')?.dataset.template}`)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.text();
    })
    .then(data => {
      // console.log(data);
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, 'text/html');
      const cartDrawer = doc.getElementById('Cart-Drawer');
      const cartDrawerHTML = cartDrawer.innerHTML;
      const cartDprice = doc.querySelector('.thb-items-price').innerHTML;
      
      document.querySelector('#Cart-Drawer').innerHTML = cartDrawerHTML;
      document.querySelector('.thb-items-price').innerHTML = cartDprice;

      $('.cart-rp-wrapper').slick({infinite: false, slidesToShow: 1,slidesToScroll: 1,arrows: true,dots: false});
      pairwithDisabled();
      
      let product_drawer = document.getElementById("Product-Drawer"),
        search_drawer = document.getElementById("Search-Drawer");
  
      if (search_drawer.classList.contains("active")) {
        search_drawer.classList.remove("active");
      }
      if (product_drawer && product_drawer.contains(form)) {
        product_drawer.classList.remove("active");
        form.body.classList.remove("open-cc--product");
        if (document.getElementById("Cart-Drawer")) {
          form.body.classList.add("open-cc");
          document.getElementById("Cart-Drawer").classList.add("active");
        }
      } else if (document.getElementById("Cart-Drawer")) {
        form.body.classList.add("open-cc");
        document.getElementById("Cart-Drawer").classList.add("active");
        dispatchCustomEvent("cart-drawer:open");
      }
    })
    .catch(error => {
      console.error('There has been a problem with your fetch operation:', error);
    });
}

function qtyPlusMinus(button){
    const bType = button.dataset.type;
    const input = button.closest('.custom-quantity').querySelector('input');
    const qty = parseInt(input.value);
    const line = input.dataset.line;
    const vid = input.dataset.vid;
    button.disabled = true;
    button.closest('.product-cart-item').classList.add('thb-loading');
     if(bType == 'plus'){
         input.value = qty + 1;
         updateCartItem(line, qty + 1,vid);
     }else{
       if(qty >= 2){
        input.value = qty - 1;
        updateCartItem(line, qty - 1,vid);
       }
     }
}

function removeItem(rbtn){
  const line = rbtn.dataset.line;
  const vid = rbtn.dataset.vid;
  rbtn.closest('.product-cart-item').classList.add('thb-loading');
  updateCartItem(line, 0,vid);
}

async function updateCartItem(line, qty, vid){
  const cartReq = await fetch(window.Shopify.routes.root + 'cart.js');
  const cartJson = await cartReq.json();
  const cartItem = cartJson.items;
  const hasFreeItem = cartItem.filter(item => item.properties?.__main_product_id == vid && item.properties?.__sock != 'yes');
  const hasSockItem = cartItem.filter(item => item.properties?.__main_product_id == vid && item.properties?.__sock == 'yes');
  
  console.log('hasFreeItem ',hasFreeItem);
  let formData = {'line': line,'quantity': qty};
  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(formData)
  })
  .then(response => {
    if(hasFreeItem.length > 0){
      updateCartItemFilter(hasFreeItem[0].key,qty, hasSockItem);
    }else{
      window.cartUpdate();
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function updateCartItemFilter(id, qty, hasSockItem){
  let formData = {'id': id,'quantity': qty};
  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(formData)
  })
  .then(response => {
    window.cartUpdate();
    // if(hasSockItem.length > 0 && qty == 0){
    //   updateCartItemSock(hasSockItem);
    // }else{
    //   window.cartUpdate();
    // }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function updateCartItemSock(hasSockItem){
  let formData = {'id': hasSockItem[0].key,'quantity': 0};
  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(formData)
  })
  .then(response => {
    window.cartUpdate();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

/* custom cart drawer js */
// const pspPrice = document.querySelector('select.combine-variants-wrap option:first-child').dataset.price;
// document.querySelector('.thb-secondary-item-icon .thb-items-price').innerHTML = pspPrice;

// document.querySelector('.thb-custom-drawer').addEventListener('click', function(){
//    this.classList.toggle('active');
//    document.querySelector('.cart-dropdown-overlay').classList.toggle('active');
// });

// document.querySelector('.cart-dropdown-overlay').addEventListener('click', function(){
//    document.querySelector('.thb-custom-drawer').classList.toggle('active');
//    document.querySelector('.cart-dropdown-overlay').classList.toggle('active');
// });

// window.customcartUpdate();

/* jquery code start here */

$('.iwts--carousel').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
});




$('.cw-slider-wrap').slick({
    infinite: false,
    loop:true,
    slidesToShow: 5.3,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    nextArrow: $(".sliderNewNext"),
    prevArrow: $(".sliderNewPrev"),
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          loop: false,
        }
      }
    ]
});

$('.cw-slider-mobile-wrap').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    draggable: false,
    touchMove: false,
    swipe: false
});

var selectBox = document.querySelector('.cw-wrapper-mobile select.cw-dropdown');
if(selectBox){
selectBox.addEventListener('change', function(){
    const comname = this.value;
    var selectedOption = selectBox.options[selectBox.selectedIndex];
    var dataIndexValue = selectedOption.getAttribute('data-index');
    console.log('comname ',comname);
    $('.cw-slider-mobile-wrap').slick('slickGoTo', dataIndexValue);
});
}

$('.cart-rp-wrapper').slick({
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: false
  });

// image text slider section
$('.sliderImgTx').slick({
      slidesToShow: 2.2,
      slidesToScroll: 1,              
      infinite:false,
      arrows:false,
     responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2.2,
          }
        },
       {
          breakpoint: 575,
          settings: {
            slidesToShow:1.1,
          }
        }
      ]
    });


// image text slider section
$('.imgSlider').slick({
      slidesToShow: 4,
      centerMode: true,
      centerPadding:'80px',
      slidesToScroll: 1,              
      infinite:true,
      arrows:false,
      responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 3,
              }
            },
           {
              breakpoint: 750,
              settings: {
                slidesToShow:2,
                centerPadding:'50px',
                arrows:true,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow:1,
                centerPadding:'30px',
                arrows:true,
              }
            }
          ]
    });


// Left Right text image section title slick

  $('.heaidngLoop').slick({
      slidesToShow: 1,
      slidesToScroll: 1,              
      infinite:false,
      arrows:false,
      autoplay:true,
      fade: true,
      speed: 500,
      infinite: true,    
      adaptiveHeight: false
    });



// chart tab box

$(function () {

  var activeIndex = $('.tabArea .active-tab').index(),
      $contentlis = $('.tabArea .tabs-content .TabContent'),
      $tabslis = $('.tabArea .tabs li');
  
  // Show content of active tab on loads
  $contentlis.eq(activeIndex).show();

  $('.tabArea .tabs').on('click', 'li', function (e) {
    var $current = $(e.currentTarget),
        index = $current.index();
    
    $tabslis.removeClass('active-tab');
    $current.addClass('active-tab');
    $contentlis.hide().eq(index).show();
	 });
});


// delivery Count animation
  $(".count").each(function () {
    var xval = $(this).attr("title");
    var only_txt = xval.slice(0, -1);
    var result = xval.toString().slice(-1);
    console.log(result);
    if (result == "+") {
      $(this).parent().append(result);
    } else if (result == "%") {
      $(this).parent().append(result);
    } else if (result == "K" || result == "k") {
      $(this).parent().append(result);
    } else {
      only_txt = only_txt + result;
    }
  
    $(this)
      .prop("Counter", 0)
      .animate(
        {
          Counter: only_txt
        },
        {
          duration: 6000,
          easing: "swing",
          step: function (now) {
            $(this).text(Math.ceil(now).toLocaleString());
          }
        }
      );
  });



$('.whiteSliderBox').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow: $('.arrbtn .prv-arr'),
    nextArrow: $('.arrbtn .nxt-arr'),
});



// get max height airspase section
let maxHeight = Math.max(...$('.boxMain .boxItem').map(function() {
    return $(this).height();
}).get());
maxHeight = maxHeight + "px";
$('.airWrp .contentArea').css('--height',maxHeight )

function newcrpButtonClick(button){
  button.classList.add('loading');
  const form = button.closest('form');
  const main_vid = form.querySelector('input[name="id"]').value;
  let formDatacus = {'items': [{'id': main_vid,'quantity': 1}]};
  const has_auto_filter = form.querySelector('input[name="addon-id"]');
  
  if(has_auto_filter){
    const filter_id = has_auto_filter.value;
    const filter_sellingplan_id = has_auto_filter.getAttribute('data-sellingid');
    if(filter_sellingplan_id){
        formDatacus.items.push({'id': filter_id,'quantity': 1, 'selling_plan': filter_sellingplan_id, properties: {'__main_product_id': main_vid}});
      }else{
        formDatacus.items.push({'id': filter_id,'quantity': 1, properties: {'__main_product_id': main_vid}}); 
      }
  }
  
    
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(formDatacus)
    })
    .then(response => {
      // console.log('response ',response);
      window.cartUpdate();
      setTimeout(function() {
        document.querySelector('button.single-add-to-cart-button').classList.remove('loading');
      },1000);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

$('.nswf-tab-content-wrapper').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    draggable: false
});

document.querySelectorAll('.nswf-tab-button button.nswf-button').forEach((button,index) => {
    button.addEventListener('click', function(){
        document.querySelector('.nswf-tab-button button.nswf-button.active')?.classList.remove('active');
        this.classList.add('active');
        $('.nswf-tab-content-wrapper').slick('slickGoTo', index)
    });
});

document.querySelectorAll('.nswf-tab-content button.nswf-atc-filter').forEach(button => {
   button.addEventListener('click', function(){
       const main_vid = this.dataset.vid;
       const filter_vid = this.dataset.filterVid;
       const filter_sid = this.dataset.filterSid;
       let formDatacus = {'items': [{'id': main_vid,'quantity': 1}]};
       if(filter_sid){
         formDatacus.items.push({'id': filter_vid,'quantity': 1, 'selling_plan': filter_sid, properties: {'__main_product_id': main_vid}});
       }else{
         formDatacus.items.push({'id': filter_vid,'quantity': 1, properties: {'__main_product_id': main_vid}});
       }
       button.classList.add('loading');
       button.disabled = true;
       fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(formDatacus)
        })
        .then(response => {
          window.cartUpdate();
          setTimeout(function() {
            button.classList.remove('loading');
            button.disabled = false;
          },1000);
        })
        .catch((error) => {
          console.error('Error:', error);
        });
   });
});

// class add off N/A Content
document.querySelectorAll('.tff-row').forEach(div => {
    if (div.textContent.trim() === 'N/A') {
        div.classList.add('na-class');
    }
});

const see_all_filter_btn = document.querySelector('.cyfs-compare-section.see-all-filter button.see-all-filter-btn');
if(see_all_filter_btn){
    see_all_filter_btn.addEventListener('click', function(){
        see_all_filter_btn.closest('.cyfs-compare-section').classList.remove('see-all-filter');
    });
}

$('.listHead .ctw-row').click(function(){
  $('.dfw-text').removeClass('showTab');
  $('.compare-types-wrap .ctw-row').removeClass('showTab');
  $('.ctw-row').removeClass('activeTitle');
  
  let attrVal = $(this).attr('data-title');
  let attrGnt = `[data-title="${attrVal}"]`;
   $('.filter-details-wrap').find(attrGnt).addClass('showTab');
   $('.compare-types-wrap').find(attrGnt).addClass('showTab');

  $(this).toggleClass('activeTitle');
  sortFilter();
});

function sortFilter(){
  
  const filterArr = [];
  document.querySelectorAll('.filter-details-wrap .fdw-wrap.tbb-filter').forEach((filter, index) => {
      const text = filter.querySelector('.showTab')?.innerText;
      if (!text) {
        filterArr.push({ 'index': index, 'value': index });
      } else {
        const value = parseInt(text);
        filterArr.push({ 'index': index, 'value': value });
      }
  });
  
  filterArr.sort((a, b) => b.value - a.value);
  filterArr.forEach((item, index) => {
  document.querySelectorAll('.filter-details-wrap .fdw-wrap.tbb-filter')[item.index].style.order = index + 1;
  });
}



let country_code = document.querySelector('.shopify-localization-form input[name="country_code"]').value;
console.log('country_code ',country_code);
preorderCounteryWise();
pairwithDisabled();

function preorderCounteryWise(){
  // Remove the "preorder_now" class from the body
  document.body.classList.remove("preorder_now");

  const vid = document.querySelector('.pfi-filter-block.active select.filter-product-variants')?.value;
  const sku = document.querySelector('.pfi-filter-block.active select.filter-product-variants option:checked')?.dataset.sku;
  console.log('sku ', sku);

  // Ensure `this.currentVariant` is defined
  if (vid) {
    // Check for Canada SKU and availability
    if (canada_sku.includes(sku)) {
      if (country_code === 'CA') {
        setTimeout(() => {
          document.body.classList.add("preorder_now");
          const buttonText = document.querySelector('button.single-add-to-cart-button span.single-add-to-cart-button--text');
          if (buttonText) {
            buttonText.innerHTML = 'Preorder Now';
          }
        }, 0);
      }
    }
    // Check for US SKU and availability
    if (us_sku.includes(sku)) {
      if (country_code === 'US') {
        setTimeout(() => {
          document.body.classList.add("preorder_now");
          const buttonText = document.querySelector('button.single-add-to-cart-button span.single-add-to-cart-button--text');
          if (buttonText) {
            buttonText.innerHTML = 'Preorder Now';
          }
        }, 0);
      }
    }

    console.log('country_code ',country_code);
    if (canada_sku_oos.includes(sku)) {
      if (window.location.pathname.includes('en-ca') || country_code === 'CA') {
        setTimeout(() => {
          const buttonText = document.querySelector('button.single-add-to-cart-button span.single-add-to-cart-button--text');
          if (buttonText) {
            buttonText.innerHTML = 'Out Of Stock';
            document.querySelector('button.single-add-to-cart-button').disabled = true;
          }
        }, 0);
      }
    }
    
    if (us_sku_oss.includes(sku)) {
      if (country_code === 'US') {
        setTimeout(() => {
          const buttonText = document.querySelector('button.single-add-to-cart-button span.single-add-to-cart-button--text');
          if (buttonText) {
            buttonText.innerHTML = 'Out Of Stock';
            document.querySelector('button.single-add-to-cart-button').disabled = true;
          }
        }, 0);
      }
    }

    if (uk_sku.includes(sku)) {
      if (country_code === 'GB') {
        setTimeout(() => {
          document.body.classList.add("preorder_now");
          const buttonText = document.querySelector('button.single-add-to-cart-button span.single-add-to-cart-button--text');
          if (buttonText) {
            buttonText.innerHTML = 'Preorder Now';
          }
        }, 0);
      }
    }

    if (uk_sku_oos.includes(sku)) {
      if (country_code === 'US') {
        setTimeout(() => {
          const buttonText = document.querySelector('button.single-add-to-cart-button span.single-add-to-cart-button--text');
          if (buttonText) {
            buttonText.innerHTML = 'Out Of Stock';
            document.querySelector('button.single-add-to-cart-button').disabled = true;
          }
        }, 0);
      }
    }


    if (au_sku.includes(sku)) {
      if (country_code === 'AU') {
        setTimeout(() => {
          document.body.classList.add("preorder_now");
          const buttonText = document.querySelector('button.single-add-to-cart-button span.single-add-to-cart-button--text');
          if (buttonText) {
            buttonText.innerHTML = 'Preorder Now';
          }
        }, 0);
      }
    }

    if (au_sku_oos.includes(sku)) {
      if (country_code === 'AU') {
        setTimeout(() => {
          const buttonText = document.querySelector('button.single-add-to-cart-button span.single-add-to-cart-button--text');
          if (buttonText) {
            buttonText.innerHTML = 'Out Of Stock';
            document.querySelector('button.single-add-to-cart-button').disabled = true;
          }
        }, 0);
      }
    }
    
  } else {
    console.error('currentVariant is undefined or null.');
  }
};

function pairwithDisabled(){
  document.querySelectorAll('#Cart-Drawer .crp-item button.crp-atc').forEach(crpButton => {
      const sku = crpButton.dataset.sku;
  
      if (canada_sku_oos.includes(sku)) {
          if (country_code === 'CA') {
              crpButton.disabled = true;
          }
      }
  
      if (us_sku_oss.includes(sku)) {
          if (country_code === 'US') {
              crpButton.disabled = true;
          }
      }
  });
}



